import React from "react";
import { formatCurrency } from "../../../../utils/SamuiUtils";
import { formatThaiDateUi } from "../../../../utils/DateUtils";

const DataTable = React.memo(
  ({ fields, data, onSort, sortField, sortOrder, onRowClick, sums }) => (
    <div className="card p-2">
      <div className="table-responsive" style={{ height: "70vh", overflowY: "auto" }}>
        <table className="table table-striped table-hover">
          <thead className="thead-dark">
            <tr>

              {fields.map((f) => (
                <th
                  key={f.key}
                  style={{
                    cursor: f.sortable ? "pointer" : "default",
                  }}
                  className={`text-${f.alignHeader} text-nowrap`}
                  onClick={() => f.sortable && onSort(f.key)}
                >
                  {f.label}
                  {f.sortable && (
                    <span className="ms-1">
                      {f.key === sortField ? (
                        sortOrder === "asc" ? (
                          <i className="fas fa-sort-up text-white"></i>
                        ) : (
                          <i className="fas fa-sort-down text-white"></i>
                        )
                      ) : (
                        <i className="fas fa-sort text-muted" style={{ opacity: 0.5 }}></i>
                      )}
                    </span>
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((item, i) => (
                <tr key={i} style={{ cursor: "pointer" }} onClick={() => onRowClick(i)}>
                  {fields.map((f) => (
                    <td key={f.key} className={`text-${f.align}`}>
                      {f.key === "Doc_Date"
                        ? formatThaiDateUi(item[f.key])
                        : f.numeric
                          ? formatCurrency(item[f.key])
                          : item[f.key]}

                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={fields.length + 1}>
                  <center><h5>ไม่พบข้อมูล</h5></center>
                </td>
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={2} className="text-center">
                รวมลูกค้า {data.length} รายการ
              </th>
              <th className="text-end">{formatCurrency(sums.sumTotal_Before_Vat)}</th>
              <th className="text-end">{formatCurrency(sums.sumDiscount_Value)}</th>
              <th className="text-end">{formatCurrency(sums.sumVAT)}</th>
              <th className="text-end">{formatCurrency(sums.sumNetTotal)}</th>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  )
);

export default DataTable;
formatThaiDateUi